var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenquoteright(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000287655 21.9393C4.77157 19.6833 7.15747 17.0326 7.15747 13.987C5.12356 13.7614 3.4417 12.9624 2.11184 11.59C0.781974 10.2176 0.117056 8.62907 0.117056 6.82429C0.117056 4.90671 0.762419 3.28995 2.05317 1.97397C3.34392 0.657979 4.96711 -2.351e-06 6.92279 -2.18003e-06C9.11315 -1.98854e-06 11.0101 0.855377 12.6138 2.56616C14.2175 4.27694 15.0193 6.35429 15.0193 8.79826C15.0193 16.1302 10.7559 21.864 2.22918 26L-0.000287655 21.9393ZM16.8398 21.9393C21.6508 19.6833 24.0562 17.0326 24.0562 13.987C21.9832 13.7614 20.2818 12.9624 18.9519 11.59C17.6221 10.2176 16.9572 8.62907 16.9572 6.82429C16.9572 4.90671 17.6123 3.28995 18.9226 1.97397C20.2329 0.657981 21.8659 -8.73659e-07 23.8216 -7.02688e-07C26.0119 -5.112e-07 27.8991 0.855379 29.4832 2.56616C31.0673 4.27694 31.8594 6.35429 31.8594 8.79827C31.8594 16.1302 27.6156 21.864 19.128 26L16.8398 21.9393Z",
    fill: "#14C7C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenquoteright);
export default __webpack_public_path__ + "static/media/greenquoteright.6b8c9a8381e04aa60fd4a87902aa4671.svg";
export { ForwardRef as ReactComponent };